import styled from "styled-components";
import { fontFamilies } from "components/shared/tokens/typography";

export const BreadcrumbText = styled.p`
  margin: 0;
  color: rgba(118, 124, 143, 1);
  font-family: ${fontFamilies.regular};
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0%;
`;

export const BreadcrumbLink = styled.button`
  border: 0;
  padding: 0;
  background: none;
  color: inherit;
  font: inherit;
  cursor: pointer;
`;
